import { useParams } from 'react-router-dom'
import { isPrivacyCenterContentLoading } from 'common/query-screen-status'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { isEmpty } from 'lodash'
import { isValidProductId } from 'pages/product-details/services/ProductDetails.services'

export function useProduct() {
  const { privacyCenterContent, isAppLoading, isAppError, userSelectedEntity } = useAppContext()

  const { productId } = useParams()

  const validProductId = userSelectedEntity
    ? isValidProductId(userSelectedEntity, productId)
    : undefined

  const productsContent = privacyCenterContent?.components?.products?.content

  const productContent =
    validProductId && productsContent ? productsContent[validProductId] : undefined

  const isContentLoading = isPrivacyCenterContentLoading(isAppLoading, !!productsContent)

  const isError =
    isAppError ||
    !userSelectedEntity ||
    isEmpty(privacyCenterContent?.components?.products?.content)

  const isErrorOrInactive =
    isError || !privacyCenterContent?.components?.products?.isActive || !productContent

  return {
    entity: userSelectedEntity,
    validProductId,
    isContentLoading,
    isErrorOrInactive,
    productId,
    productContent,
  }
}
